export default {
    name: "post-list",
    data() {
        return {
            isLoading: true,
            search: '',
            currentPage: 1,
            perPage: this.postsPerPage,
            motion: {
                repeat: true, // infinite animation until stopped
                rollback: true, // reverse animation until return to the first keyframe
                instantRollback: true, // instantly return to the first keyframe
                delay: 0, // delay before the start
                stepDelay: 0, // delay between keyframes
                factor: 1, // delay factor (number of steps to skip) before every step
                skip: 0, // number of steps to skip before the first flip
                duration: 600, // default duration. might be overridden by duration-{value} Tailwind class
                ease: 'ease-in-out', // transition timing function
            }
        }
    },

    props: {
        posts: Array,
        postsPerPage: Number,
    },

    watch: {
        search(newVal, oldVal) {
            this.currentPage = 1;
        },
    },

    computed: {
        postsList() {
            return this.posts.filter(post => {
                return post.title.toLowerCase().includes(this.search.toLowerCase())
            })
        },

        printedPosts() {
            const start = this.currentPage * this.perPage - this.perPage,
                end = this.currentPage * this.perPage;

            return this.postsList.slice(start, end)
        },

        postsAmount() {
            return this.posts.length
        },

        pages() {
            return Math.round(this.postsList.length / this.perPage);
        }
    },
}